import React, { Component } from 'react';
import { connect } from 'react-redux';
import Zigzag from './../../../../containers/UI/Common/Shapes/Zigzag';

export class BadgeSummary extends Component {

  state = {};

  componentDidMount() {
    const _state = {};

    for ( let index in this.props.allBadges) {
      _state[index] = false;
    }

    this.setState(_state);
  }

  onClickHandler = (index) => {
    let _state = { ...this.state };

    if (this.state[index]) {
      _state[index] = false;
    } else {
      for (let i in this.state) {
        _state[i] = false;
      }
      _state[index] = true;
    }
    
    this.setState(_state);
  }

  render() {
    let containerOutput = null;
    if (this.props.userBadges.length > 0) {

      containerOutput = this.props.allBadges.map((badgeElement, index) => {
        let badgeClass = '';
        if (this.props.userBadges[index] === true) {
          return (
            <div className="bloc-image" key={`badge-bloc-${index}`} onClick={this.onClickHandler.bind(this, index)}>
              <div className={`tooltip${this.state[index]?" show":""}`}>
                <div className="badge-name">{badgeElement.name}</div>
                <div className="badge-info">Tu as débloqué ce badge en cumulant {badgeElement.pointsRequired} points</div>
              </div>
              <img  src={badgeElement.imgHover} className={badgeClass} alt={`badge ${badgeElement.name}`} />
            </div>);
        }
        return (
          <div className="bloc-image" key={`badge-bloc-${index}`} onClick={this.onClickHandler.bind(this, index)}>
            <div className={`tooltip${this.state[index]?" show":""}`}>
              <div className="badge-name">{badgeElement.name}</div>
              <div className="badge-info">Pour débloquer ce badge, il te faut {badgeElement.pointsRequired} points</div>
            </div>
            <img src={badgeElement.img} className={badgeClass} alt={`badge ${badgeElement.name}`} />
          </div>);

      });
    }

    let pointsLabelOutput = (Number.parseInt(this.props.currentPoints, 0) > 0) ? 'points' : 'point';

    return (
      <div className="badge-summary-container">
        <div className="yellow-shape-start">    
          <Zigzag color="#ffde39" />
        </div>
        
        {containerOutput}
        <div className="points-container">
          <span className="total-points">{this.props.currentPoints}</span>
          <span className="label-points">{pointsLabelOutput}</span>
        </div>

        <div className="yellow-shape-end">    
          <Zigzag color="#ffde39" />
        </div>
        <div className="blue-shape-end">    
          <Zigzag color="#0cafe8" />
        </div>
    </div>);
  };
}

export default connect(null)(BadgeSummary);


// WEBPACK FOOTER //
// ./src/components/UI/Common/BadgeSummary/BadgeSummary.js